/** @file English catalog part of area E8 (W3-03); replaced whole by that area. */

/** The `live`, `activity` and `aiView` blocks (spread at the top level). S0 composes it into `en`. */
export const liveEn = {
  live: {
    pills: 'Who is here', offline: 'Offline, reconnecting…', connecting: 'Connecting…', live: 'Live',
    catchingUp: 'Catching up…', resyncing: 'Reloading the document…',
    online: '{actor}', editing: '{actor}: {name}', recent: '{actor}: active',
  },
  activity: {
    title: 'Activity', empty: 'No changes yet.', rev: 'r{rev}', revert: 'Revert', reverting: 'Reverting…',
    reverted: 'reverted', repair: 'repair', revertOf: 'reverts r{rev}', sending: '{names}: sending…', retry: 'Retry', dismiss: 'Dismiss',
    loadOlder: 'Load older', commandTimes: '{name} ×{n}', moreTargets: '+{n}', openAiView: 'Show the renders of {actor}',
  },
  aiView: {
    title: 'AI view', actors: 'Actors', allActors: 'All', empty: 'No renders yet. Renders made through MCP or REST appear here for 24 hours.',
    loadOlder: 'Load older', open: 'Open full size', close: 'Close', expired: 'This link has expired.', setup: 'setup pose',
    contactSheet: 'contact sheet', spriteSheet: 'sprite sheet', gif: 'GIF', frame: 'frame {n}', time: '{s} s',
    compare: 'r{a} vs r{b}', autorig: 'autoRig review', meta: 'r{rev} · {w}×{h}',
  },
} as const;
